import Box from '@mui/material/Box';
import styled from '@emotion/styled';
import { DEFAULT_TOOLBAR_HEIGHT } from 'config/const';

export const ToolbarWrapper = styled(Box)(({ theme, sx, bgc }) => {
  const { main, secondary, unselected, selected } = theme.palette.toolbar;
  return {
    padding: '8px 16px 12px 16px',
    '&  svg.active path': { fill: unselected },
    '& .Mui-selected svg.active path': {
      fill: selected,
    },
    '& svg.stroke': {
      '& line, & path': {
        stroke: unselected,
      },
    },
    '& .Mui-selected svg.stroke': {
      '& line, & path': {
        stroke: selected,
      },
    },
    '& .MuiBottomNavigationAction-label': {
      width: '100%',
      '& span': {
        color: unselected,
      },
    },
    '& .Mui-selected .MuiBottomNavigationAction-label': {
      width: '100%',
      '& span': {
        color: selected,
      },
    },
    '& .MuiBottomNavigation-root': {
      background: 'transparent',
      height: DEFAULT_TOOLBAR_HEIGHT,
    },
    '& .Mui-able.MuiButton-outlinedPrimary': {
      color: selected,
      borderColor: main,
    },
    '& .Mui-able.MuiButton-containedPrimary': {
      border: `1px solid ${main}`,
      background: main,
    },
    backgroundColor: bgc || `linear-gradient(180deg, ${secondary}, white)`,
    ...sx,
  };
});
